module.exports = __webpack_public_path__ + "static/media/GOLDCOIN.ae6b6c20.svg";